import { useEffect, useState } from 'react'
import EventEmitter, {
  SHOW_POPUP_FACTSHEET,
} from '../../../helpers/EventEmitter'
import { PopupAction } from '../PopupAction'
import { Content } from './Content'
import './i18n'

export const PopupFactsheet = () => {
  const [isShow, setIsShow] = useState(false)

  const handleClose = () => {
    setIsShow(false)
  }

  useEffect(() => {
    const showPopup = (isShow) => {
      setIsShow(isShow)
    }

    EventEmitter.subscribe(SHOW_POPUP_FACTSHEET, showPopup)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_FACTSHEET, showPopup)
    }
  }, [])

  return (
    <PopupAction
      appendStyle={{
        backgroundColor: '#F3F3F3',
        borderRadius: 4,
        width: 930,
        padding: 20,
      }}
      isShow={isShow}
      title={'common.popup.popupFactsheet.TITLE'}
      handleClose={handleClose}
    >
      <Content />
    </PopupAction>
  )
}
